import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

import { EditImage } from 'client/shared/components';
import BannerImageEditor from './banner-image-editor';

@observer
class AccountHeader extends Component {
	render () {
		const { artist, user } = this.props;

		const profileImgSrc = user.profileImagePath;

		return (
			<section id="section-profile-media" className="acms-section acms-section--profile-media">
				<div className="section-title artist heading margin-bottom-1 acms-section-heading">Profile Image</div>
				{/* No grid wrapper — Foundation's grid-padding-x would re-add
				    a left gutter and the profile image would no longer align
				    with the banner image's left edge. */}
				<EditImage
					item={ user }
					mode="profile"
					imgData={user.profileImageData}// This value comes from selecting and croping an image, it is base64 encoded
					imgSrc={ profileImgSrc }// this value is dynamic and generated by the store, it is a string image path
					handleImageCrop={ (cropResult) => this.handleImageCrop(cropResult, user) }
				/>

				<div className="section-title artist heading margin-bottom-1 margin-top-2 acms-section-heading">Mobile and Web Banner Images</div>
				<p className="acms-section-blurb">
					These images headline your profile. The <strong>web banner</strong> is wide
					(roughly 3:1) and appears at the top of your artist page on the website. The
					<strong> mobile banner</strong> is portrait (9:16) and fills the hero in the
					mobile app. Hover and click either thumbnail to crop or replace it — they're
					saved independently.
				</p>

				<div className="grid-x margin-bottom-2">
					<div className="cms-banner cell small-12">
						<BannerImageEditor artist={ artist } />
					</div>
				</div>
			</section>
		);
	}

	// Saving image data works by sending base64 data to the server where is gets saved as a jpeg

	@autobind
	handleImageCrop (cropResult, user) {
		// Updating this field auto-triggers a save
		user.profileImageData = cropResult;
	}
}

export default AccountHeader;
